@if (vorgang | async; as _vorgang) {
	<schir-int-client-verfuegungen-in-vorgang [vorgang]="_vorgang"
	                                          class="x-section__container" data-test-id="verfuegungen-in-vorgang"
	                                          data-help-anchor="_spalte_verfuegungen"/>
}
